import { Chip, Paper, Typography } from "@mui/material";
import SmartAvatar from "../Avatar/SmartAvatar";
import ReferralListSkeleton from "./ReferralListSkeleton";

function normalizeStatus(s = "") {
  const x = s.toLowerCase();
  if (x === "accepted") return "Accepted";
  if (x === "invited") return "Invited";
  return s || "";
}

function toDisplay(row = {}) {
  const badge = normalizeStatus(row.status || "");
  const isInvited = badge === "Invited";
  const isAccepted = badge === "Accepted";
  const TotalEarnings =
    row.referredTotal != 0 ? `Earned ${row.referredTotal}` : null;
  const TotalMilestones = 10;

  const title = isInvited
    ? row.email || "invite@example.com"
    : row.DoctorName || row.name || "—";

  return {
    id: row._id ?? "",
    badge,
    isInvited,
    isAccepted,
    title,
    TotalEarnings,
    TotalMilestones,
    avatar: {
      src: isAccepted ? row.coverPic || row.profile || "" : "",
      name: isAccepted ? row.DoctorName || row.name || "" : "",
      email: isInvited ? row.email || "" : "",
    },
    raw: row,
  };
}

export default function ReferralList({
  list = [],
  loading = false,
  onOpenReferral,
  emptyText = "No referrals yet",
}) {
  if (loading) return <ReferralListSkeleton count={5} />;

  const items = (Array.isArray(list) ? list : []).map(toDisplay);
  if (!items.length) {
    return (
      <Paper sx={{ p: 2, borderRadius: 2, border: "1px solid #eee" }}>
        <Typography variant="body2" color="text.secondary">
          {emptyText}
        </Typography>
      </Paper>
    );
  }

  return (
    <div className="space-y-6">
      {items.map((it, idx) => {
        const clickable = it.isAccepted && typeof onOpenReferral === "function";
        return (
          <div key={it.id || `ref-${idx}`} className="flex gap-3">
            {/* timeline marker */}
            {/* <div className="flex flex-col items-center">
              <span className="w-3 h-3 rounded-full border-2 border-gray-400 bg-white" />
              {idx < items.length - 1 && (
                <span className="h-full w-px bg-gray-300" />
              )}
            </div> */}

            {/* content */}
            <div
              className={`flex-1 ${clickable ? "cursor-pointer" : ""}`}
              onClick={() => {
                if (clickable) onOpenReferral(it.raw);
              }}
            >
              {/* top card with earnings */}
              {/* {it.TotalEarnings && (
                <div className="mb-2 flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-800">
                  <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
                    <span className="text-blue-500">👤</span>
                    {it.title} has earned referral rewards
                  </div>
                  <span className="rounded-lg bg-green-100 px-2 py-1 text-xs font-medium text-green-700">
                    {it.TotalEarnings}
                  </span>
                </div>
              )} */}

              {/* details */}
              <div className="flex items-center gap-3">
                <SmartAvatar
                  src={`${process.env.REACT_APP_API_URL}/${it.avatar.src}`}
                  name={it.avatar.name}
                  email={it.avatar.email}
                  size={44}
                />
                <div className="flex-1 min-w-0">
                  <Typography
                    variant="body1"
                    fontWeight={700}
                    noWrap
                    title={it.title}
                    className="text-gray-900 dark:text-gray-100"
                  >
                    {it.title}
                  </Typography>
                  {it.TotalMilestones && (
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      Milestones : {it.TotalMilestones}
                    </p>
                  )}
                  {
                it.TotalEarnings != null &&
                <Chip
                  label={it.TotalEarnings}
                  size="small"
                  sx={{
                    borderRadius: "10px",
                    paddingLeft: "14px",
                    paddingRight: "14px",
                    fontWeight: 600,
                    backgroundColor: "rgba(34,197,94,0.12)",
                    color: "#166534",
                    height: 30,
                    marginTop: "4px"
                  }}
                />
              }
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
